module.exports = __webpack_public_path__ + "static/media/feature3.5acc2610.jpeg";